import { useId, useState } from 'react';

import { classlist } from '~/_shared/design-system/lib/classlist';
import { TextButton } from '~/_shared/design-system/ui/atoms/button/text/text-button';
import { Label } from '~/_shared/design-system/ui/atoms/label/label';
import {
	TextInput,
	type TextInputProps,
} from '~/_shared/design-system/ui/atoms/text-input/text-input';

import './labeled-password-input.css';

interface LabeledPasswordInputProps
	extends Omit<TextInputProps, 'id' | 'type'> {
	label: string;
	id?: string;
	wrapper_className?: string;
	show_label?: string;
	hide_label?: string;
}

const LabeledPasswordInput = ({
	label,
	id,
	wrapper_className,
	className,
	show_label = 'Show',
	hide_label = 'Hide',
	...inputProps
}: LabeledPasswordInputProps) => {
	const [is_visible, setIsVisible] = useState(false);
	// Instance-unique default id (explicit `id` prop wins) — see
	// LabeledInput; the toggle button's id derives from the resolved id.
	const auto_id = useId();
	const resolved_id = id ?? `LabeledPasswordInput-${auto_id}`;
	return (
		<div className={classlist('labeled-password-input', wrapper_className)}>
			<Label htmlFor={resolved_id}>{label}</Label>
			<div className='labeled-password-input__row'>
				<TextInput
					{...inputProps}
					id={resolved_id}
					type={is_visible ? 'text' : 'password'}
					className={className}
				/>
				<TextButton
					id={`${resolved_id}-visibility-toggle`}
					type='button'
					size='sm'
					aria-pressed={is_visible}
					onClick={() => setIsVisible((v) => !v)}
				>
					{is_visible ? hide_label : show_label}
				</TextButton>
			</div>
		</div>
	);
};

export type { LabeledPasswordInputProps };
export { LabeledPasswordInput };
